<template>
    <div class="bg-0A1129">
       <div style="width:85%;margin:0 auto">
        <span v-html="t('whyUs')" class="custom-grey-badge mt-5">
            </span>

           <h4 v-html="t('whyUsSub')" class="custom-54px-600 text-white mt-3 mb-5"></h4>
      
           <br /><br />
           <CRow>
        <CCol
          md="6"
          v-for="(feature, index) in features"
          :key="index"
          class="mb-4"
        >
          <CCard
            class="h-100"
            :class="{
              'custom-navy-border': index !== features.length - 1,
              'gradient-box': index === features.length - 1
            }"
          >
            <CCardBody>
              <!-- <img :src="feature.icon" alt="icon" class="mb-3" width="20px"/> -->
              <h5 class="font-weight-bold font-Montserrat mt-3 custom-20px-400">
                {{ feature.title }}
              </h5>
              <p
                class="font-color-C1C1D2 custom-16px-400 mt-3"
                style="line-height: 180%;"
              >
                {{ feature.description }}
              </p>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      
        </div>
      
            
            
            
    </div>
</template>
  
<script>
import { translations } from '@/bm.js'
import { langState } from '@/main.js'
export default {
    data() {
        return {
         
        }
    },
    methods: {
    t(key) {
      return translations[langState.currentLang][key] || ''
    }
},
computed: {
    t() {
      return (key) => translations[langState.currentLang][key] || ''
    },
    features() {
      return translations[langState.currentLang].features || []
    }
  }


    
}
</script>

<style scoped>
.why-section {
    background-color: #0b163f;
    position: relative;
}
</style>